import { getCdnBaseUrl } from '@/config/env-config';

const PLAY_STORE_BADGE_PATH = '/icons/google-play-badge.svg';
const APP_STORE_BADGE_PATH = '/icons/app-store-badge.svg';

export function getPlayStoreBadgeUrl() {
  return `${getCdnBaseUrl()}${PLAY_STORE_BADGE_PATH}`;
}

export function getAppStoreBadgeUrl() {
  return `${getCdnBaseUrl()}${APP_STORE_BADGE_PATH}`;
}
